export default "__VITE_ASSET__c04362ce__"